import { Component, Injector } from '@angular/core';
import { Subscription } from 'rxjs';
import { appearance } from 'src/app/config/appearance';
import { Color } from 'src/app/config/color';
import { locales } from 'src/app/config/i18n-config';
import { CanvasLayoutDataService } from '../angular-common/canvas-layout-data.service';
import { PageLayoutDataService } from '../angular-common/page-layout-data.service';
import { RoutingDataService } from '../angular-common/routing-data.service';
import { SecurityDataService } from '../angular-common/security-data.service';
import { formatInteger } from './forms/forms-util';

@Component({ template: '' })
export class BaseView {
    public securityDataService: SecurityDataService;
    public canvasLayoutDataService: CanvasLayoutDataService;
    public pageLayoutDataService: PageLayoutDataService;
    public routingDataService: RoutingDataService;

    public widthInPx: number;
    public isMobile: boolean; // < 1024px
    public isXxxs: boolean;
    public isXxs: boolean;
    public isXs: boolean;
    public isS: boolean;
    public isM: boolean;
    public isL: boolean;
    public isXl: boolean;
    public isXxl: boolean;
    public isGreaterThanXxxs: boolean;
    public isGreaterThanXxs: boolean;
    public isLesserThanXs: boolean;
    public isGreaterThanXs: boolean;
    public isLesserThanS: boolean;
    public isGreaterThanS: boolean;
    public isLesserThanM: boolean;
    public isGreaterThanM: boolean;
    public isLesserThanL: boolean;
    public isGreaterThanL: boolean;
    public isLesserThanXl: boolean;
    public isGreaterThanXL: boolean;
    public isLesserThanXxl: boolean;
    //public workingWidth:number; //TODO: capire se può essere necessario

    /**
     * Contiene la lista delle azioni autorizzate per la view corrente
     */
    public authorizedActions: string[] = [];

    protected _subscription: Subscription

    appearance = appearance
    locales = locales
    Color = Color
    formatInteger = formatInteger;
    asArray = (value): any[] => value as any[]  //<= serve per castare ad array in un template (che non permette il casting)
    asFile = (value): File => value as File     //<= serve per castare a file in un template (che non permette il casting)

    constructor(protected _injector: Injector) {
        this.securityDataService = _injector.get(SecurityDataService);
        this.canvasLayoutDataService = _injector.get(CanvasLayoutDataService);
        this.pageLayoutDataService = _injector.get(PageLayoutDataService);
        this.routingDataService = _injector.get(RoutingDataService);

        this._subscription = new Subscription()
            .add(_injector.get(CanvasLayoutDataService).widthObs.subscribe(width=>this._updateWindowSizeProperties(width)))
            //.add(_injector.get(CanvasLayoutDataService).workingWidthObs.subscribe(workingWidth=>this.workingWidth=workingWidth))
    }

    ngOnInit(): void {
        
        //TODO: sarebbe bello farlo qui in maniera centralizzata ma non assegna gli overload ma solo la funzione definita qui
        //this.pageLayoutDataService.manageFabButtonSetClick=this.manageFabButtonSetClick.bind(this);
    }

    ngOnDestroy(): void {
        this._subscription.unsubscribe();
    }

    public eventStopper(event){
        console.log('!!!eventStopper :>> ', event);
        event.stopPropagation()
    }

    private _updateWindowSizeProperties(width) {
        this.widthInPx = this._injector.get(CanvasLayoutDataService).width;
        this.isMobile = this.isLesserThanM;
        this.isXxxs = this._injector.get(CanvasLayoutDataService).isXxxs();
        this.isXxs = this._injector.get(CanvasLayoutDataService).isXxs();
        this.isXs = this._injector.get(CanvasLayoutDataService).isXs();
        this.isS = this._injector.get(CanvasLayoutDataService).isS();
        this.isM = this._injector.get(CanvasLayoutDataService).isM();
        this.isL = this._injector.get(CanvasLayoutDataService).isL();
        this.isXl = this._injector.get(CanvasLayoutDataService).isXl();
        this.isXxl = this._injector.get(CanvasLayoutDataService).isXxl();
        this.isGreaterThanXxxs = this._injector.get(CanvasLayoutDataService).isGreaterThanXxxs();
        this.isGreaterThanXxs = this._injector.get(CanvasLayoutDataService).isGreaterThanXxs();
        this.isLesserThanXs = this._injector.get(CanvasLayoutDataService).isLesserThanXs();
        this.isGreaterThanXs = this._injector.get(CanvasLayoutDataService).isGreaterThanXs();
        this.isLesserThanS = this._injector.get(CanvasLayoutDataService).isLesserThanS();
        this.isGreaterThanS = this._injector.get(CanvasLayoutDataService).isGreaterThanS();
        this.isLesserThanM = this._injector.get(CanvasLayoutDataService).isLesserThanM();
        this.isGreaterThanM = this._injector.get(CanvasLayoutDataService).isGreaterThanM();
        this.isLesserThanL = this._injector.get(CanvasLayoutDataService).isLesserThanL();
        this.isGreaterThanL = this._injector.get(CanvasLayoutDataService).isGreaterThanL();
        this.isLesserThanXl = this._injector.get(CanvasLayoutDataService).isLesserThanXl();
        this.isGreaterThanXL = this._injector.get(CanvasLayoutDataService).isGreaterThanXL();
        this.isLesserThanXxl = this._injector.get(CanvasLayoutDataService).isLesserThanXxl();
    }

    // async manageFabButtonSetClick(event: any){
    //     console.log('BaseView.manageFabButtonSetClick()');
    // }
}
